export default function Input({ label, ...props }) {
  return (
    <div className="flex flex-col gap-2 w-full group">
      <label
        className="font-mono text-xs uppercase tracking-widest text-collectors-gray
                group-focus-within:text-collectors-black transition-colors"
        htmlFor={label}
      >
        {label}
      </label>
      <input
        className="bg-transparent border-solid border-b-2 border-collectors-light py-2 font-display
                text-3xl md:text-4xl font-medium text-collectors-black placeholder-collectors-light
                focus:outline-none focus:border-collectors-black transition-colors duration-300 rounded-none"
        id={label}
        name={label}
        autoComplete="off"
        {...props}
      />
    </div>
  );
}
